import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAEGKfaLtG35J_XyURfEy2pqrtRCEpp7qY",
  authDomain: "listlytics.firebaseapp.com",
  projectId: "listlytics",
  storageBucket: "listlytics.firebasestorage.app",
  messagingSenderId: "303852454334",
  appId: "1:303852454334:web:6a4347a2e01e921007f9ef"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

